import { useContext, useState } from "react";
import { HomeItem } from "../../../../../models/home-rows";
import AppContext from "../../../../../services/app-context-services";

export const useFetchNextPage = (homeItemMain: HomeItem | null) => {
  const { dg_id: trace_id, isLoggedIn, token } = useContext(AppContext);
  const [output, setOutput] = useState<HomeItem | null>(homeItemMain);
  const [isLoading, setIsLoading] = useState(false);

  const fetchNextPage = async () => {
    if (isLoading || !homeItemMain?.next) return; // Prevent repeated calls
    // console.log("IN FETCH");

    setIsLoading(true);

    const userPlatform = process.env.NEXT_PUBLIC_USER_PLATFORM;
    const userSource = "digitoon";
    const userCampaign = "N-A";

    const queryParams = `&source=${userSource}&campaign=${userCampaign}&platform=${userPlatform}&trace_id=${trace_id}`;

    try {
      const response = await fetch(
        homeItemMain.next.replace("http:", "https:") + queryParams,
        {
          method: "GET",
          headers:
            isLoggedIn && token
              ? {
                  Authorization: `token ${token}`,
                  "Content-Type": "application/json"
                }
              : {
                  "Content-Type": "application/json"
                }
        }
      );

      if (response.ok) {
        const data = await response.json();

        if (data.results) {
          setOutput(prevState => ({
            ...prevState!,
            ugc_list: [...prevState!.ugc_list, ...data.results],
            next: data.next
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, fetchNextPage, output };
};
